<template>
    <div id="article">
      <div class="home-head">
        <head-common></head-common>
      </div>
      <div class="hone-content">
        <article-details ref="childArticleDetails" :id="id"></article-details>
      </div>
      <div class="home-footer">
        <footer-common></footer-common>
      </div>
    </div>
</template>

<script>
  import HeadCommon from "../HeadCommon";
  import ArticleDetails from "./ArticleDetails";
  import FooterCommon from "../FooterCommon";
    export default {
      name: "HomeArticleDetails",
      components: {FooterCommon, ArticleDetails, HeadCommon},
      created() {
        //this.initGetDetails(); 拿不到props的值
      },
      props: {
      },
      data: function () {
        return {
          id: this.$route.query.id
        }
      },
      methods: {
        initGetDetails: function () {
          console.log("initGetDetails:", this.id);
          debugger;
          //this.$refs.childArticleDetails.getArticleDetails(this.id);
        }
      }
    }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #article {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(178, 255, 166, 0.44);
  }
  #article .hone-content {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  #article .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/articles/HomeArticleDetails.vue